import React from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'src/utils/Http';
import { optionStylesStep2, locale } from '../customize';
import {
  targetStep0, targetStep1, targetStep2, targetStep3, targetStep4, targetStep5,
  targetStep6, targetStep7, targetStep8, targetStep9, targetStep10, targetStep11, targetStep12, targetStep13, targetStep14
} from './target/check'

export default function checkSalaryRuleStep(props) {
  const { cookie, clientPayrollRulesGroups, payrollRulesGroup,
    clientAllowances, clientUnitPrices, values, setTutorialStep2 } = props
  const { run, stepIndex, tourCompleted, type, params } = cookie
  const { t } = useTranslation()

  const step = [
    {
      target: targetStep0(),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.0'),
      disableBeacon: true,
      placement: 'auto',
    },
    {
      target: targetStep1(),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.1'),
      placement: 'auto',
    },
    {
      target: targetStep2(payrollRulesGroup),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.2'),
      placement: 'auto',
    },
    {
      target: targetStep3(payrollRulesGroup),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.3'),
      placement: 'auto',
    },
    {
      target: targetStep4(payrollRulesGroup),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.4'),
      placement: 'auto',
    },
    {
      target: targetStep5(values),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.5'),
      placement: 'auto',
    },
    {
      target: targetStep6(values),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.6'),
      placement: 'auto',
    },
    {
      target: targetStep7(values),
      content: (
        <React.Fragment>
          {t('features.GuideTour.PayrollRulesGroups.CheckStep.7').split(';').map((text, index) =>
            text != ' ' ? <p key={index} style={{ textAlign: 'left' }}>{text}</p> : <br />
          )}
        </React.Fragment>
      ),
      placement: 'auto',
    },
    {
      target: targetStep8(values),
      content: (
        <React.Fragment>
          {t('features.GuideTour.PayrollRulesGroups.CheckStep.8').split(';').map((text, index) =>
            text != ' ' ? <p key={index} style={{ textAlign: 'left' }}>{text}</p> : <br />
          )}
        </React.Fragment>
      ),
      placement: 'auto',
    },
    {
      target: targetStep9(payrollRulesGroup),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.9'),
      placement: 'auto',
    },
    {
      target: targetStep10(payrollRulesGroup),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.10'),
      placement: 'auto',
    },

    {
      target: targetStep11(payrollRulesGroup),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.11'),
      placement: 'auto',
    },
    {
      target: targetStep12(values),
      content: t('features.GuideTour.PayrollRulesGroups.CheckStep.12'),
      placement: 'auto',
    },
    {
      target: targetStep13(values),
      content: (
        <React.Fragment>
          {t('features.GuideTour.PayrollRulesGroups.CheckStep.13').split(';').map((text, index) =>
            <p key={index} style={{ textAlign: 'left' }}>{text}</p>
          )}
        </React.Fragment>
      ),
      placement: 'auto',
    },
    {
      target: targetStep14(values),
      content: (
        <React.Fragment>
          {t('features.GuideTour.PayrollRulesGroups.CheckStep.14').split(';').map((text, index) =>
            text != ' ' ? <p key={index} style={{ textAlign: 'left' }}>{text}</p> : <br />
          )}
        </React.Fragment>
      ),
      placement: 'auto',
    },
  ];
  const setStepIndex = (newIndex, newParam) => {
    setTutorialStep2({ run, stepIndex: newIndex, tourCompleted, type, params: { ...params, ...newParam } })

  }
  const setTourCompleted = () => {
    setTutorialStep2({ run: false, stepIndex: 0, tourCompleted: true, type, params })
  }

  const handleCallback = data => {
    const { action, index, lifecycle, type } = data;
    const newIndex = index + (action === 'prev' ? -1 : 1);

    if (action === 'skip') {
      setTourCompleted()
    }
    else if (type === 'step:after' && index === 0) {
      setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 1) {
      if (action === 'next') {
        setStepIndex(newIndex, { payrollRulesGroupId: clientPayrollRulesGroups[0].id })
        redirectTo(`/clients/payroll_rules_groups/${clientPayrollRulesGroups[0].id}/allowances`)
      }
      else
        setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 2) {
      setStepIndex(newIndex)
      action === 'prev' && redirectTo('/clients/payroll_rules_groups')
      action === 'next' && redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/unit_prices`)
    }
    else if (type === 'step:after' && index === 3) {
      action === 'prev' && redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/allowances`)
      setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 4) {
      if (action === 'next') {
        setStepIndex(newIndex, { id: clientUnitPrices[0].id })
        redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/unit_prices/${clientUnitPrices[0].id}/edit`)
      }
      else
        setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 5) {
      action === 'prev' && redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/unit_prices`)
      setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 6) {
      setStepIndex(newIndex)

    }
    else if (type === 'step:after' && index === 7) {
      setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 8) {
      action === 'prev' && setStepIndex(newIndex)
      // save from
    }
    else if (type === 'step:after' && index === 9) {
      setStepIndex(newIndex)
      action === 'prev' && redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/unit_prices/${clientUnitPrices[0].id}/edit`)
      action === 'next' && redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/allowances`)
    }
    else if (type === 'step:after' && index === 10) {
      action === 'prev' && redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/unit_prices`)
      setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 11) {
      if (action === 'next') {
        setStepIndex(newIndex, { allowanceId: clientAllowances[0].id })
        redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/allowances/${clientAllowances[0].id}/edit`)
      }
      else
        setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 12) {
      action === 'prev' && redirectTo(`/clients/payroll_rules_groups/${payrollRulesGroup.id}/allowances`)
      setStepIndex(newIndex)
    }
    else if (lifecycle === 'complete' && index === 13) {
      setStepIndex(newIndex)
    }
    else if (lifecycle === 'complete' && index === 14) {
      action === 'prev' && setStepIndex(newIndex) //: setTourCompleted()
    }
  };

  return (
    <Joyride
      steps={step}
      run={run}
      stepIndex={stepIndex}
      callback={handleCallback}
      styles={optionStylesStep2}
      locale={locale(t)}
      continuous
      scrollToFirstStep
      hideCloseButton
      showProgress
      showSkipButton
      disableOverlayClose
    />
  )
}